import { createFileRoute } from '@tanstack/react-router';
import { VendaExternaList } from '@/features/venda-externa/page/list/VendaExternaList';

export const Route = createFileRoute('/a/venda-externa/')({
    component: VendaExternaList,
});
